import { render, staticRenderFns } from "./DraftEvent.vue?vue&type=template&id=021b7ff8&scoped=true&"
import script from "./DraftEvent.vue?vue&type=script&lang=js&"
export * from "./DraftEvent.vue?vue&type=script&lang=js&"
import style0 from "./DraftEvent.vue?vue&type=style&index=0&id=021b7ff8&prod&lang=scss&scoped=true&"
import style1 from "./DraftEvent.vue?vue&type=style&index=1&id=021b7ff8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021b7ff8",
  null
  
)

export default component.exports